﻿

gro.modules = gro.modules || {};

gro.modules.timeBookingPage = (function () {
    var pub = {};
    pub.listIoNumbers = function (customerNo, ios) {
        var dialogHtml = '<p>Inköpsordrar kopplade till kundnummer: ' + customerNo + '</p>';
        dialogHtml += '<p>Klicka på någon av nedanstående inköpsordrar för att gå direkt till den</p><br/>';
        dialogHtml += '<table style="display: block; overflow-y: scroll; height: 300px;">' +
            '<thead><tr>' +
            '<th>IONummer</th><th>Artikel</th><th>Kv</th><th>Anläggning</th></tr></thead>' +
            '<tbody>';

        $.each(ios, function (i, d) {
            dialogHtml += '<tr><td><a href="?ion=' +
                d.IONumber +
                '">' +
                d.IONumber +
                '</a></td><td>' +
                d.ItemName +
                '</td><td>' +
                d.Quantity / 1000 +
                '</td><td>' +
                d.WarehouseName +
                '</td></tr>';
        });

        dialogHtml += '</tbody>' + '</table>';

        return dialogHtml;
    };

    var extractForDropdown = function (elId, extractFrom) {
        var arr = [],
            extractFormLen = extractFrom.length;

        if (extractFormLen === 0) {
            var name = $('#' + elId).closest('div').siblings('span').text();
            name = name.replace('*', '');
            $('#' + elId + '> ul > li').remove();
            $('#' + elId).attr('data-value', '');
            $('#' + elId).closest('div').addClass('disabled');
            $('#' + elId + '> a').html(name + ' saknas');
            $('#allowedReservations').html('0');
            UpdateAllowedReservations();
        } else {
            $('#' + elId).closest('div').removeClass('disabled');
            for (var i = 0; i < extractFormLen; i++) {

                arr[arr.length] = '<li data-value="' + extractFrom[i].Value + '"><a href="javascript:void(0)">' + extractFrom[i].Display + '<\/a><\/li>';
                if (elId == 'resourceDrp') {
                    $('#' + elId).attr('regNoMandatory', extractFrom[i].RegNoMandatory);
                    $('#' + elId).attr('allowedreservations', extractFrom[i].AllowedReservations);
                }
                if (extractFrom[i].IsSelected == true) {
                    $('#' + elId + '> a').html(extractFrom[i].Display);
                    $('#' + elId).attr('data-value', extractFrom[i].Value);
                }
            }
        }
        return arr.join('');
    };

    pub.editForm = function (editReservationData) {
        var dialogHtml = '<p>' + editReservationData.reservationDate + '</p>';
        dialogHtml += '<span>Ordernummer</span>' + '<input type="number" disabled="true" value="' + editReservationData.deliveryNo + '">';
        dialogHtml += '<span>Regnr</span>' + '<input id="license-plate-input" type="text" value="' + editReservationData.licensePlateNo + '">';
        dialogHtml += '<span>E-post</span>' + '<input id="email-address-input" type="email" value="' + editReservationData.emailAddress + '">';
        dialogHtml += '<span>Mobilnr</span>' + '<input id="mobile-no-input" type="number" value="' + editReservationData.mobileNo + '">';
        dialogHtml += '<span>Övrig Information</span>' + '<input id="note-input" type="text" value="' + editReservationData.note + '">';
        dialogHtml += '<span>Påminnelse</span>' + '<select class="js-select-combobox" id="reminder-combobox">';
        dialogHtml += getSelectComboboxValues(editReservationData.reminderInMinutesBefore);
        dialogHtml += '</select>';
        dialogHtml += '<input type="button" id="edit-form-button-save" value="Spara Ändringar" class="lm__primary-btn">';

        return dialogHtml;
    };

    var getSelectComboboxValues = function (reminderInMinutesBefore) {
        var optionHtml = getComboboxValue(0, "Ingen påminnelse", (reminderInMinutesBefore == 0));
        optionHtml += getComboboxValue(60, "En timme innan", (reminderInMinutesBefore == 60));
        optionHtml += getComboboxValue(120, "Två timmar innan", (reminderInMinutesBefore == 120));
        optionHtml += getComboboxValue(1440, "Ett dygn innan", (reminderInMinutesBefore == 1440));

        return optionHtml;
    };

    var getComboboxValue = function(value, text, selected) {
        var comboboxHtml = '<option value="' +
            value +
            '"' +
            (selected ? ' selected="selected"' : '') +
            '>' +
            text +
            '</option>';
        return comboboxHtml;
    };

    pub.getDayFullyBookedModalContent = function (firstBookableDay) {
        var firstBookableSlot = firstBookableDay.TimeSlots.filter(function (slot) {
            return !slot.IsBooked;
        })[0];

        var modalHtml = '<p align="center">Det finns inga lediga tider på </br> valt datum: </br><strong>' +
            $('#selectedDate').val() +
            "</strong></p>";
        modalHtml += '<p align="center">Nästa lediga tid: </br><strong>' +
            firstBookableDay.Date.yyyymmdd() +
            " " +
            firstBookableSlot.FromDateTime +
            "</strong></p>";
        modalHtml +=
            '<input type="button" id="js-close-modal-button" value="Se ursprungligt datum" class="lm__blue-btn" style="width: -webkit-fill-available;">' +
            '</br>' +
            '</br>' +
            '<input type="button" id="js-go-to-next-date-button" value="Gå till nästa lediga tid" class="lm__blue-btn" style="width: -webkit-fill-available;">';
        return modalHtml;
    };

    pub.getNoSlotsFoundModalContent = function() {
        var modalHtml = '<p align="center">Det finns inga lediga tider på </br> valt datum: </br><strong>' +
            $('#selectedDate').val() +
            "</strong></p>";
        modalHtml += '<p align="center">Efter sökning på valt datum</br>' +
            "och 14 dagar framåt hittades</br>" +
            "inga tider på vald anläggning.</p>" +
            "</br>";
        modalHtml += '<input type="button" id="js-close-modal-button" value="Ok" class="lm__primary-btn" style="width: -webkit-fill-available;">';
        return modalHtml;
    };

    return pub;
})();